import styled from "styled-components";
import Card from "@mui/material/Card"

export const max1lines = `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const max2lines = `
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const captionRegularAndSemibold = (theme: any) =>`
  //include captionSemibold & captionSemibold;
  font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
  line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
  @media (min-width: 960px) {
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
    line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
  }
`;

export const buttonLink = (theme: any) =>`
  font-size: ${theme.uptimeFontSizes.mobile.fz4}px;
  line-height: ${theme.uptimeLineHeights.mobile.lh4}px;
  font-weight: normal;
  @media (min-width: 960px) {
    font-size:  ${theme.uptimeFontSizes.mobile.fz4}px;
    line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
  }
`;

export const AcknowledgeCardStyle = styled(Card) `
  ${({theme}) => `
    background-color: ${theme.uptimeColors.grayScales.white};
    color: ${theme.uptimeColors.grayScales.black};
    min-height: auto;
    width: 100%;
    max-height: 300px;
    height: 300px;
    aspect-ratio: 1;
    border-radius: 10px !important;
    .MuiCardHeader-root{
      padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]};
    }
    .uptime-acknowledge-card-content {
      padding-bottom: ${theme.uptimeSpace[4]}px;
      .uptime-acknowledge-card-configuration {
        &-item-content,
        &-item-header {
          font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        }
        .uptime-acknowledge-card-deviceBrand {
          margin-bottom: 5px;
          color: ${theme.uptimeColors.grayScales.darkerGray};
          word-break: break-all;
          ${max2lines}
          ${captionRegularAndSemibold(theme)}
        }
        .uptime-acknowledge-card-deviceName {
          margin-bottom: 5px;
          color: $color-gray-dark;
          word-break: break-word;
          font-weight: 600;
          ${max2lines}
          ${captionRegularAndSemibold(theme)}
          strong{
            font-weight: bold;
            color: ${theme.uptimeColors.grayScales.black};
          }
        }
        .uptime-acknowledge-card-configuration-item {
          display: flex;
          align-items: center;
          justify-content: left;
          font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
          flex-wrap: nowrap;        
            .MuiSvgIcon-root {
              display: block;
              width: 12px;
              height: 12px;
              margin-right: ${theme.uptimeSpace[4]}px;
            }
            
            .uptime-acknowledge-card-configuration-item-header{
              ${captionRegularAndSemibold(theme)}
              margin-right: ${theme.uptimeSpace[2]}px;
              white-space: nowrap;
              font-weight: bold;
            }
            .uptime-acknowledge-card-configuration-item-content{
              color: ${theme.uptimeColors.grayScales.black};
              word-break: break-all;
              ${max1lines}
              ${captionRegularAndSemibold(theme)}
            }
        }
      }
      .uptime-acknowledge-card-content-image {
        height: 113px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  
    .uptime-acknowledge-card-footer{
      margin-top: ${theme.uptimeSpace[5]}px;
      text-align: center;
      .uptime-acknowledge-link{
        ${buttonLink(theme)};   
        color: ${theme.uptimeColors.grayScales.black};
        &:hover{
          color: ${theme.uptimeColors.grayScales.darkerGray};
          text-decoration: underline;
        }
      }
      .MuiButtonBase-root{
        font-size: ${theme.uptimeSpace[6]}px;
      }
    }
    .MuiCardContent-root{
      padding-top: ${theme.uptimeSpace[0]};
    }
  `}
`